function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-rotchi-2x-secret-a",
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAF4A4",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E8F13D",
  offset: "60.065%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E8EA12",
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "avatar-rotchi-2x-secret-b",
  width: 95,
  height: 95,
  rx: 22
}), /*#__PURE__*/React.createElement("path", {
  id: "avatar-rotchi-2x-secret-c",
  d: "M6.5 65.04V24.115C6.5 14.4 14.4 6.5 24.114 6.5h46.772C80.6 6.5 88.5 14.4 88.5 24.114v46.772C88.5 80.6 80.6 88.5 70.886 88.5H24.114c-6.137 0-11.552-3.155-14.706-7.93-1.28-2.364-1.01-4.1 1.388-4.1 2.426 0 17.786 3.154 41.988 2.07C76.987 77.458 83 62.7 76.987 50.29c-6.015-12.408-20.24-10.49-29.473-9.035 3.243-2.03 19.286-11.61 20.93-12.888 1.643-1.278 2.528-1.695 2.528-2.777V21.7c0-2.927-2.227-2.696-3.593-2.696H28.866c-1.59 0-2.606.937-2.606 2.695v2.77c0 1.77.403 2.555 2.345 2.555h26.527S34.93 39.878 27.61 44.26c-7.32 4.38-6.113 7.963-6.113 10.89 0 2.926 2.575 1.057 4.422.19 9.856-4.636 19.22-6.715 29.563-6.715 10.344 0 13.818 10.725 8.172 16.456-4.02 4.084-16.86 4.9-23.52 4.9C24.12 69.98 17.02 69.78 9 68.357c-1.17-.207-2.27-1.142-2.5-3.314z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "url(#avatar-rotchi-2x-secret-a)",
  xlinkHref: "#avatar-rotchi-2x-secret-b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#avatar-rotchi-2x-secret-c"
}));

var SvgRocchi = function SvgRocchi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRocchi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rocchi.67127905.svg";
export { ForwardRef as ReactComponent };